import { Tabs } from 'antd';
import { TabsProps } from 'antd/lib/tabs';
import { FC, StyleHTMLAttributes, useMemo } from 'react';

export type TabComponentProps = {
  tabList: (
    | string
    | {
        title: string;
        icon?: React.ReactNode;
        key?: string;
        style?: StyleHTMLAttributes<HTMLElement>;
        disabled?: boolean;
      }
  )[];
  onChangeTab: (item: string) => void;
  defaultActiveKey?: string;
} & Omit<React.ComponentProps<typeof Tabs>, 'onChange'>;

export const TabComponent: FC<TabComponentProps> = ({
  tabList,
  onChangeTab,
  defaultActiveKey = '0',
  ...rest
}) => {
  //used to force the component to re-render when the tabList changes
  const tabsKey = useMemo(() => Math.random().toString(), [tabList]);

  const tabListToRender = useMemo(
    () =>
      tabList.map((item, index) => ({
        key: typeof item === 'object' && item.key ? item.key : `${index}`,
        label: (
          <span style={typeof item === 'object' ? item.style : {}}>
            {typeof item === 'object' && item.icon}
            {typeof item === 'object' ? item.title : item}
          </span>
        ),
        disabled: typeof item === 'object' ? item.disabled : false,
      })) as TabsProps['items'],
    [tabList]
  );
  return (
    <Tabs
      key={tabsKey}
      defaultActiveKey={defaultActiveKey}
      onChange={onChangeTab}
      {...rest}
      items={tabListToRender}
    />
  );
};
